import React, { ChangeEvent } from 'react'
import styled from 'styled-components'
import ErrorMessage from './error-message'
import theme from './theme'

interface TextAreaProps {
  label: string
  placeholder?: string
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  errorMessage?: string
  onBlur?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  name?: string
  maxLength?: number
}

interface TextAreaStyleProps {
  showError: boolean
}

const Label = styled.label`
  display: block;
  font-family: ${theme.fonts.secondary};
  font-size: 1.8rem;
  padding-bottom: 1.6rem;
`

const CustomTextArea = styled.textarea`
  border: 2px solid
    ${(props: TextAreaStyleProps): string =>
      props.showError ? theme.colours.danger1 : theme.colours.black};
  border-radius: 0.4rem;
  font-family: ${theme.fonts.secondary};
  font-size: 1.8rem;
  padding: 0.8rem 1.6rem;
  width: 100%;
  height: 22rem;
  resize: none;
  &::placeholder {
    font-size: 1.6rem;
  }
`

const TextAreaContainer = styled.div`
  flex: 1;
`

const TextArea = (props: TextAreaProps): JSX.Element => {
  return (
    <TextAreaContainer>
      <Label>{props.label}</Label>
      <CustomTextArea
        onChange={props.onChange}
        showError={!!props.errorMessage}
        placeholder={props.placeholder}
        id={props.name}
        name={props.name}
        onBlur={props.onBlur}
        maxLength={props.maxLength || 99999}
      />
      {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
    </TextAreaContainer>
  )
}

export default TextArea
